import React, { useState, useEffect, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import { Html, useTexture, CubicBezierLine, Text } from "@react-three/drei";
import { OverlayTrigger, Popover } from "react-bootstrap";

export default function ArtificialSatellite(props) {
  const mesh = useRef();
  const textRef = useRef();

  const popover = (
    <Popover id="popover-basic" className="mini-globe-popup globe-satellite-popup">
      <div className="globe-popup-body">
        <div className="popup-content-wrapper">
          <div className="connecting-line"></div>
          <div className="mg-text-wrapper">
            <div className="mini-globe-text">Program Outline</div>
          </div>
        </div>
      </div>
    </Popover>
  );
  // useFrame(() => {
  //     if (!isStop)
  //         mesh.current.rotation.z += 0.001;
  // });
  const texture = useTexture("Satelite.png");
  const [hovered, setHovered] = useState(false);
  const [isStop, setIsStop] = useState(false);

  useEffect(() => {
    document.body.style.cursor = hovered ? 'pointer' : 'auto';
  }, [hovered]);
  return (
    <group ref={mesh} position={props.position}>
      <mesh position={props.position}>
        <Html zIndexRange={[0, 0]}>
          <div onClick={props.onclick} className="globe-satellite-outer-ring  globe-artificial">
            <OverlayTrigger
              trigger={["hover", "focus", "click"]}
              placement="right-end"
              overlay={popover}
              rootClose
            >
              <div className="globe-satellite"><div className="globe-dash-line"></div></div>
              
            </OverlayTrigger>
          </div>
        </Html>
        {/* <sphereGeometry args={[0.1, 100, 100]} />
        <meshStandardMaterial
          attach="material"
          color="#00AEFF"
          transparent
          roughness={0}
          metalness={0}
          opacity={1}
        /> */}
      </mesh>
      {/* <mesh
        position={props.position}
        onPointerOver={(event) => {
          console.log(event);
          setHovered(true);
          setIsStop(true);
        }}
        onPointerOut={(event) => {
          console.log(event);
          setHovered(false);
          setIsStop(false);
        }}
        onClick={props.onclick}
      >
        <sphereGeometry args={[0.2, 100, 100]} />
        <meshStandardMaterial
          attach="material"
          color="#00AEFF"
          transparent
          roughness={0}
          metalness={0}
          opacity={0.5}
        />
      </mesh> */}

      {hovered && (
        <mesh position={props.textposition}>
          {/* <planeGeometry args={[5, 1]} />
          <meshStandardMaterial
            roughness={0.5}
            color="#005587"
            opacity={0}
            transparent
          /> */}
          {/* <Text
                    ref={textRef}
                    color={"#00AEFF"}
                    fontSize={0.3}
                    maxWidth={100}
                    lineHeight={1}
                    letterSpacing={0.02}
                    textAlign={"left"}
                    position={[0, 0, 0.01]}
                    overflowWrap="break-word"
                    whiteSpace="overflowWrap"
                >
                    Program Outline
                </Text> */}
          {/* <Html>
            <div id="popover-basic" className="mini-globe-popup">
              <div className="globe-popup-body">
                <div className="popup-content-wrapper">
                  <div className="connecting-line"></div>
                  <div className="mg-text-wrapper">
                    <div className="mini-globe-text">Program Outline</div>
                  </div>
                </div>
              </div>
            </div>
          </Html> */}
        </mesh>
      )}

      {hovered && (
        <mesh position={props.position}>
          {/* <ringBufferGeometry attach="geometry" args={[0.5, 0.5 + 0.03, 128]} /> */}
        </mesh>
      )}

      <group position={props.position}>
        <sprite>
          <spriteMaterial
            attach="material"
            map={texture}
            transparent
            opacity={1}
            metalness={1}
            roughness={1}
          />
        </sprite>
        {/* <pointLight /> */}
      </group>
    </group>
  );
}
